<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/listbox';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '../package.json';

```jsx import
import {ListBox, Section, Item} from '@react-spectrum/listbox';
```

---
category: Collections
---

# ListBox

<p>{docs.exports.ListBox.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['ListBox']} />

## Example

```tsx example
<ListBox width={200} aria-label="label">
  <Section title="Justify">
    <Item>Left</Item>
    <Item>Middle</Item>
    <Item>Right</Item>
  </Section>
  <Section title="Align">
    <Item>Top</Item>
    <Item>Center</Item>
    <Item>Bottom</Item>
  </Section>
</ListBox>
```

## Content

### Accessibility

### Internationalization

## Events

## Props

<PropTable component={docs.exports.ListBox} links={docs.links} />

## Visual options
